module.exports = __webpack_public_path__ + "static/images/finance-4.d403e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/finance-4.png
// module id = 4xJo
// module chunks = 8